import React, { useState} from "react";
import Tabs from "react-bootstrap/esm/Tabs";
import Tab from "react-bootstrap/Tab";
import { toast } from "react-toastify";
import Toast from "../LoadingError/Toast";
import axios from "axios";
import { BASE_URL } from "../../api/baseConfig";
import { IContentTypeEdit } from "./MainContentType";
import { IContentTypeCreate } from "./MainContentType";
import { langTypes } from "@/types";
const ToastObjects = {
  pauseOnFocusLoss: false,
  draggable: false,
  pauseOnHover: false,
  autoClose: 2000,
};
type language = {name: string, id: number}
const languages: language[] = [{name: "AZ", id: 1}, {name: "EN", id: 2}, {name: "TR", id: 3}, {name: "RU", id: 4}]

const initialLangNames = [
  {name: "", lang_code: "AZ"},
  {name: "", lang_code: "EN"},
  {name: "", lang_code: "TR"},
  {name: "", lang_code: "RU"},
]

interface ICreateContentTypeProps {
  contentType: IContentTypeEdit | null | IContentTypeCreate
  onCancelEdit: () => void
  loadContentTypes: (page: number, lang: langTypes) => void
  page: number
}

const CreateContentType = (props: ICreateContentTypeProps) => {

  const [slugName, setSlugName] = useState("")
  const [type, setType] = useState("")
  const [rowNumber, setRowNumber] = useState(0)
  const [isOriginal, setIsOriginal] = useState(false)
  const [langNames, setLangNames] = useState(initialLangNames);
  const token = JSON.parse(localStorage.getItem("userInfo")!).token;

  const createContentType = React.useCallback((contentType: IContentTypeCreate) => {
    axios
      .post(BASE_URL + "/api/contentType/add", contentType, {
        headers: { "x-access-token": token },
      })
      .then((response) => {
        props.loadContentTypes(props.page, 'AZ');
        toast.success("ContentType created successfully", ToastObjects);
      });

  }, [props, token]);
  const editContentType = React.useCallback((contentType: IContentTypeEdit) => {
    axios
      .put(BASE_URL + "/api/contentType/update/" + contentType.id, contentType, {
        headers: { "x-access-token": token },
      })
      .then((response) => {
        props.loadContentTypes(props.page, 'AZ');
        toast.success("ContentType edited successfully", ToastObjects);
        props.onCancelEdit()
      });

  }, [props, token]);
  const submitHandler = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (props.contentType && 'id' in props.contentType) {
      editContentType({
        id: props.contentType.id, 
        language: langNames, 
        slug: slugName,
        type: type,
        row_number: rowNumber,
        is_original: isOriginal
      })
      
    } else {
      createContentType({
        language: langNames, 
        slug: slugName,
        type: type,
        row_number: rowNumber,
        is_original: isOriginal
      })
    }
    setLangNames(initialLangNames);
    setSlugName("");
    setType("");
    setRowNumber(0);
    setIsOriginal(false);
  }

  
  React.useEffect(() => {
    if (props.contentType) {
      setLangNames(props.contentType.language);
      setSlugName(props.contentType.slug);
      setType(props.contentType.type || "");
      setRowNumber(props.contentType.row_number || 0);
      setIsOriginal(props.contentType.is_original || false);
    } else {
      setLangNames(initialLangNames);
      setSlugName("");
      setType("");
      setRowNumber(0);
      setIsOriginal(false);
    }
  }, [props.contentType])

  const langNameChangeHandler = React.useCallback((language: language, newValue: string) => {
    setLangNames((prev) => {
      const newLangNames = [...prev];
      const langCode = language.name;
      const langIndex = newLangNames.findIndex((l) => l.lang_code === langCode);
      const newLangValue = {...newLangNames[langIndex]};
      newLangValue.name = newValue;
      newLangNames[langIndex] = newLangValue;
      return newLangNames
    });
  }, [])

  return (
    <>
    <Toast />
    <div className="col-md-12 col-lg-4">
      <form onSubmit={submitHandler}>
        <Tabs>
          {languages &&
            languages.map((l, index) => (
              <Tab eventKey={l.name} title={l.name} key={`movie-tab-${l.id}`}>
                <div className="mb-4">
                  <label
                    htmlFor={`product_title-${l.id}`}
                    className="form-label"
                  >
                    contentType title {l.name}
                  </label>
                  <input
                    type="text"
                    placeholder="Type here"
                    className="form-control"
                    id={`product_title-${l.id}`}
                    name="name"
                    required
                    value={langNames[index].name}
                    onChange={e => langNameChangeHandler(l, e.target.value)}
                  />
                </div>
              </Tab>
            ))}
        </Tabs>
        <div className="mb-4">
          <label htmlFor="slug">Slug</label>
          <input className="form-control"
            placeholder="slug" id="slug" name="slug" value={slugName}
            required
            onChange={e=>setSlugName(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="type">Type</label>
          <input className="form-control"
            placeholder="Type (e.g. film)" id="type" name="type" value={type}
            required
            onChange={e=>setType(e.target.value)}
          />
        </div>
        <div className="mb-4">
          <label htmlFor="rowNumber">Row Number</label>
          <input className="form-control"
            type="number"
            placeholder="Row Number" id="rowNumber" name="rowNumber" value={rowNumber}
            required
            onChange={e=>setRowNumber(parseInt(e.target.value) || 0)}
          />
        </div>
        <div className="mb-4 form-check">
          <input 
            type="checkbox" 
            className="form-check-input" 
            id="isOriginal" 
            checked={isOriginal}
            onChange={e=>setIsOriginal(e.target.checked)}
          />
          <label className="form-check-label" htmlFor="isOriginal">Is Original</label>
        </div>
        <div className="d-grid">
          {props.contentType?.language? (
            <>
            <button className="btn btn-warning py-3 mb-3" type="submit">Edit ContentType</button>
            <button type="button" onClick={props.onCancelEdit} className="btn btn-secondary py-3">Cancel</button>

            </>
          

          ):(
            <button type="submit" className="btn btn-primary py-3">Create ContentType</button>
          )}
        </div>
      </form>
    </div>
  </>
  );
};

export default CreateContentType;
